
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate, useParams, useLocation } from "react-router-dom"
import { InAppTemplate } from "../../../shared/templates/inapp";


import BackIco from "../../../assets/back.svg"

import AddIco from "../../../assets/icons/add.png"
import { useWindowSize } from "../../../hooks/useWindowSize";

import AllProductsListManagement from "../products/product-listing"
import "../index.scss"
import { appActions } from '../../../redux/actions/in-app';
import { StoreProductPageProps } from '../../../types/app/StoreProductTypes';



const getStoreDetails = async ({ pageProps, payload }: { pageProps: StoreProductPageProps, payload: string }) => {
    await pageProps.getStoreDetailsAction(payload);
};


const InAppContent = ({ pageProps }: { pageProps: StoreProductPageProps }) => {
    const { storeId } = useParams();


    useEffect(() => {
        getStoreDetails({
            pageProps,
            payload: `?Id=${storeId}`,
        });
    }, [])

    return (
        <div className="inapp-content">
            <div className="page-content dashboard">
                <AllProductsListManagement storeData={{ id: storeId, name: pageProps.getStoreDetailsRequest?.request_data?.response?.data?.name }} />
            </div>
        </div>
    )
}

const StoreProductsManagement = (pageProps: StoreProductPageProps) => {
    return (
        <InAppTemplate pageHeadingTitle="Products Management" childComponent={<InAppContent pageProps={pageProps} />} />
    )
}


const mapDispatchToProps = {
    getStoreDetailsAction: appActions.GetStoreDetails,

};

const mapStateToProps = (state: any) => ({
    getStoreDetailsRequest: state.allInAppReducers.getStoreDetailsReducer,
})
export default connect(mapStateToProps, mapDispatchToProps)(StoreProductsManagement);